var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductFunnel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 5,
    fill: "#C9E58E",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_2601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9392 5.76172H8.00241C7.77748 5.76172 7.56176 5.85606 7.4027 6.02398C7.24365 6.1919 7.1543 6.41965 7.1543 6.65713L7.21325 15.7922C7.21329 15.8721 7.23358 15.9505 7.27201 16.0193C7.31045 16.0882 7.36563 16.1449 7.43183 16.1836C7.49803 16.2223 7.57284 16.2416 7.64849 16.2395C7.72415 16.2374 7.79789 16.214 7.86206 16.1716L11.0298 14.0814L14.198 16.1716C14.2622 16.2138 14.3359 16.2371 14.4115 16.2392C14.487 16.2412 14.5617 16.2219 14.6279 16.1832C14.694 16.1445 14.7491 16.0878 14.7875 16.0191C14.8259 15.9503 14.8462 15.872 14.8463 15.7922L14.7874 6.65713C14.7874 6.41965 14.698 6.1919 14.5389 6.02398C14.3799 5.85606 14.1642 5.76172 13.9392 5.76172Z",
    fill: "#525252"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_2601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(3.5 3.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductFunnel);
export default __webpack_public_path__ + "static/media/product-funnel.3080e442.svg";
export { ForwardRef as ReactComponent };